import DispatchConstants from 'app/shared/constants/DispatchConstants';

const initState = () => ({
    isCharging: false,
    isCharged: false,
    apiAccessToken: '',
    error: null,
    isPaymentPending: false,
    validPaymentExists: false,
    listingCannotBeActivated: false,
});

const reducer = (state = initState(), action) => {
    switch (action.type) {
        case DispatchConstants.LISTING_CANNOT_BE_ACTIVATED:
            return { ...state, listingCannotBeActivated: true, error: action.payload };
        case DispatchConstants.INITIATE_CREDIT_CARD_CHARGE_SUCCESS:
            return { ...state, apiAccessToken: action.payload.apiAccessToken };
        case DispatchConstants.PERFORM_CHARGE:
            return { ...state, isCharging: true };
        case DispatchConstants.PERFORM_CHARGE_SUCCESS:
            return { ...state, isCharging: false, isCharged: true };
        case DispatchConstants.INITIATE_CREDIT_CARD_CHARGE_PENDING:
            return {
                ...state, isPaymentPending: true, isCharging: false, error: action.payload,
            };
        case DispatchConstants.INITIATE_CREDIT_CARD_CHARGE_VALID_PAYMENT_EXISTS:
            return {
                ...state, isCharging: false, isCharged: true, isPaymentPending: false, validPaymentExists: true,
            };
        case DispatchConstants.INITIATE_CREDIT_CARD_CHARGE_FAIL:
        case DispatchConstants.PERFORM_CHARGE_FAIL:
            return { ...state, isCharging: false, error: action.payload };
        case DispatchConstants.MODAL_HIDE:
            return initState();
        default:
    }
    return state;
};

export default reducer;
